import type { SaversTrailerMovement } from '../../types';

export const normalizeGeneratePartnerRequest = (
  // biome-ignore lint/suspicious/noExplicitAny: TODO: Add types here
  data: any,
  type: string,
  trailerMovementData: SaversTrailerMovement,
  customerKey: number,
  shipmentType: string,
) => {
  return {
    book: Number(data.trailerShippings[0][`${shipmentType}bookweight`]),
    customerKey: customerKey,
    furn: Number(data.trailerShippings[0][`${shipmentType}furn`]),
    isGeneratePayment: type === 'Generate Payment',
    isInboundTransfer: type === 'Generate Inbound Transfer',
    isOutboundTransfer: type === 'Generate Outbound Transfer',
    misc: Number(data.trailerShippings[0][`${shipmentType}miscweight`]),
    oli: Number(data.trailerShippings[0][`${shipmentType}oli`]),
    receivedAtLocation: type === 'Received at location',
    shipmentNumber: trailerMovementData.shipmentNo,
    soft: Number(data.trailerShippings[0][`${shipmentType}softweight`]),
    trailerMovementId: trailerMovementData.trailerMovementID,
  };
};
